




import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdOutlineRule, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import ModuleTabChooser from "../ReusableComponents/ModuleTabChooser";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import Atribuicoes from './Atribuicoes';
import AtribuicoesRedacoes from './AtribuicoesRedacoes';
import { PreferencesContext } from '../../contexts/PreferencesContext';


class ShowDemanda extends Component {
    static contextType = PreferencesContext;

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            faculdade: {},
            demanda: {},
            show_more:false,

            activeTab: -1,
            keywords:''
        };

    }


    get_demanda(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_demanda/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_demanda();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    let keywords='';
                    resp.demanda.keywords.map((item,id)=>{
                        keywords+=((id>0?', ':'')+item.name)
                    })

                    this.setState({
                        loading_screen: false, demanda: resp.demanda,
                        keywords:keywords
                    });
                    // if (resp.demanda != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: -1 });
        this.get_demanda(this.props.match.params.id);
    }







    render() {
        const { t } = this.context || { t: key => key };

        if (this.state.loading_screen) return <SkeletonCoursePage />
        else return (
            <div style={{ position: "relative" }}>
                <div className="card">
                    <div className="card-body">
                        <div style={{ float: 'right' }}>
                            <DefaultButton
                                bg="secondary"
                                text={t('action_back')}
                                icon={<RiArrowGoBackLine />}
                                to={`/demandas` }
                            />
                        </div>
                        <div className="flex jcsb">
                            <h4 className="header">{this.state.demanda.name}</h4>
                        </div>

                       
                        <TextReadMore title={`${t('label_end')}: `} element="div" limit={1000} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                            {moment(this.state.demanda.data_encerramento).format('DD/MM/YYYY HH:mm')}
                        </TextReadMore>
                        {this.state.demanda.descricao!=null && <TextReadMore title={`${t('label_description')}: `} element="div" limit={120} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                            {this.state.demanda.descricao}
                        </TextReadMore>}

                        {this.state.demanda.keywords.length>0 && <TextReadMore title={`${t('label_keywords')}: `} element="div" limit={120} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                            {this.state.keywords }
                        </TextReadMore>}
                       
                        {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
                            <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
                            <br/>
                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.demanda.regras }}>
                            </div>
                        </div> */}
                        {/* <div className="w100 flex align-center fdcolumn margin-bottom">
                            <div className="course-banner" style={{
                                backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
                                backgroundSize: "contain",
                                backgroundRepeat:'no-repeat',
                                backgroundPositionX:'center',
                                width: "100%",
                                height: "200px",
                                borderRadius: "7px"
                            }} />
                        </div> */}

                        <ModuleTabChooser
                            activeTab={this.state.activeTab}
                            modules={[
                                { id: 0, title: t('title_question_assignments'), description: t('desc_question_assignment') },
                                { id: 1, title: t('title_essay_assignments'), description: t('desc_essay_assignment') },
                            ]}
                            onSelect={(value) => {
                                this.setState({ activeTab: value });
                                this.props.history.push({ search: `?tab=${value}` });
                            }}
                            onBack={() => {
                                this.setState({ activeTab: -1 });
                                this.props.history.push({ search: '' });
                            }}
                        />
                        <TabPanel value={this.state.activeTab} index={0}>
                            <Atribuicoes demanda_id={this.state.demanda.id} demanda_name={this.state.demanda.name} />
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index={1}>
                            <AtribuicoesRedacoes demanda_id={this.state.demanda.id} demanda_name={this.state.demanda.name} />
                        </TabPanel>

                    </div>
                </div>

            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowDemanda);
